import AccountTableChart from "features/portfolio/Accounts/AccountTableChart";
import React from "react";
import { RawChartData, SingleValueChartData } from "@shared/types";
import useGraphDataSocket from "@shared/services/socket/useGraphDataSocket";

interface LiveSmallChartProps {
  symbol: string;
  exchange: string;
  initialGraphData: SingleValueChartData | RawChartData;
  isPrice?: boolean;
  yValueIndex?: number;
  fontSize?: number;
  chartHeight?: number;
}

const LiveSmallChart = ({
  symbol,
  exchange,
  initialGraphData,
  isPrice,
  yValueIndex,
  fontSize,
  chartHeight,
}: LiveSmallChartProps) => {
  const { graphData } = useGraphDataSocket(symbol, exchange);

  return (
    <AccountTableChart
      data={graphData ?? initialGraphData}
      isPrice={isPrice}
      yValueIndex={yValueIndex}
      fontSize={fontSize}
      chartHeight={chartHeight}
    />
  );
};

export default LiveSmallChart;
